<template>
  <div class="cu-title">
    <div @click="toggleShrink">
      <svg-icon icon-class="view-list" class="expen-con" />
    </div>
    <div class="main-title">{{ getTitle }}</div>
    <div class="sub">
      <slot></slot>
    </div>
  </div>
</template>

<script>

import {mapMutations} from "vuex"

export default {
  name: "cuTitle3",
  props:{

  },
  computed: {
    getTitle(){
      return this.$route.meta.title
    },
  },
  methods: {
    ...mapMutations("app", ["toggleShrink"]),
  }

}
</script>

<style scoped lang="less">
.cu-title{
  display: flex;
  align-items:center;
  //margin: 20px 0 ;
  background-color: white;
  padding-top: 20px;
  padding-bottom:  10px;

  .main-title{
    font-weight: 500;
    //font-size: 18px;
    font-size: 1.1rem;
    color: rgba(0,0,0,0.85);
    line-height: 16px;
  }
  .sub{
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.65);
    line-height: 16px;
    margin-left: 8px;
  }
  .expen-con{
    width:30px;
    height:30px;
    margin-right:10px;
  }
  
}
</style>